import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungMuenster() {
  return (
    <CityPageTemplate
      city="Münster"
      slug="muenster"
      intro="In der Fahrradstadt Münster denken viele nachhaltig – das gilt auch für smarte Geldanlage."
      description="Unabhängige Finanzberatung für Münster – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
